import React from 'react';

export default () => (
  <svg width="162" height="139" viewBox="0 0 162 139" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <text fontSize="16" fontWeight="400" fill="#CD3F39" transform="translate(36 100)">
        <tspan x="0" y="37">{`Environments`}</tspan>
      </text>
      <g opacity=".15">
        <path
          d="M140.5 104.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
          fill="#FBE3E2"
        />
        <path
          d="M140.5 100a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5"
          fill="#CD3F39"
        />
        <path
          d="M159.5 104.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
          fill="#FBE3E2"
        />
        <path
          d="M159.5 100a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5"
          fill="#CD3F39"
        />
        <path
          d="M158.371 112.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
          fill="#FBE3E2"
        />
        <path
          d="M158.371 108a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5"
          fill="#CD3F39"
        />
        <path
          d="M158 102h-16v1h5c1.93 0 3.5 1.57 3.5 3.5 0 2.481 2.019 4.5 4.5 4.5h1v-1h-1c-1.93 0-3.5-1.57-3.5-3.5 0-1.421-.675-2.675-1.707-3.5H158v-1z"
          fill="#CD3F39"
        />
      </g>
      <g opacity=".25">
        <path
          d="M106.5 104.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
          fill="#FBE3E2"
        />
        <path
          d="M106.5 100a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5"
          fill="#CD3F39"
        />
        <path
          d="M125.5 104.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
          fill="#FBE3E2"
        />
        <path
          d="M125.5 100a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5"
          fill="#CD3F39"
        />
        <path
          d="M124.371 112.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
          fill="#FBE3E2"
        />
        <path
          d="M124.371 108a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5"
          fill="#CD3F39"
        />
        <path
          d="M124 102h-16v1h5c1.93 0 3.5 1.57 3.5 3.5 0 2.481 2.019 4.5 4.5 4.5h1v-1h-1c-1.93 0-3.5-1.57-3.5-3.5 0-1.421-.675-2.675-1.707-3.5H124v-1z"
          fill="#CD3F39"
        />
      </g>
      <g opacity=".35">
        <path d="M72.5 104.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2" fill="#FBE3E2" />
        <path
          d="M72.5 100a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5"
          fill="#CD3F39"
        />
        <path d="M91.5 104.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2" fill="#FBE3E2" />
        <path
          d="M91.5 100a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5"
          fill="#CD3F39"
        />
        <path
          d="M90.371 112.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"
          fill="#FBE3E2"
        />
        <path
          d="M90.371 108a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5"
          fill="#CD3F39"
        />
        <path
          d="M90 102H74v1h5c1.93 0 3.5 1.57 3.5 3.5 0 2.481 2.019 4.5 4.5 4.5h1v-1h-1c-1.93 0-3.5-1.57-3.5-3.5 0-1.421-.675-2.675-1.707-3.5H90v-1z"
          fill="#CD3F39"
        />
      </g>
      <path
        d="M39.962 105.808a1.694 1.694 0 0 1-1.693-1.693c0-.933.76-1.692 1.693-1.692s1.692.76 1.692 1.692c0 .934-.76 1.693-1.692 1.693"
        fill="#FBE3E2"
      />
      <path
        d="M39.962 102a2.115 2.115 0 1 0-.001 4.23 2.115 2.115 0 0 0 0-4.23m0 .846a1.27 1.27 0 0 1 0 2.538c-.7 0-1.269-.569-1.269-1.269s.57-1.269 1.27-1.269"
        fill="#CD3F39"
      />
      <path
        d="M56.038 105.808a1.694 1.694 0 0 1-1.692-1.693c0-.933.76-1.692 1.692-1.692.934 0 1.693.76 1.693 1.692 0 .934-.76 1.693-1.693 1.693"
        fill="#FBE3E2"
      />
      <path
        d="M56.038 102a2.115 2.115 0 1 0 0 4.23 2.115 2.115 0 0 0 0-4.23m0 .846a1.27 1.27 0 0 1 0 2.538c-.7 0-1.269-.569-1.269-1.269s.57-1.269 1.27-1.269"
        fill="#CD3F39"
      />
      <path
        d="M55.083 112.577a1.694 1.694 0 0 1-1.692-1.692c0-.934.759-1.693 1.692-1.693.934 0 1.693.76 1.693 1.693s-.76 1.692-1.693 1.692"
        fill="#FBE3E2"
      />
      <path
        d="M55.083 108.77a2.115 2.115 0 1 0 0 4.23 2.115 2.115 0 0 0 0-4.23m0 .845a1.27 1.27 0 0 1 0 2.538c-.7 0-1.269-.569-1.269-1.268 0-.7.57-1.27 1.27-1.27"
        fill="#CD3F39"
      />
      <path
        d="M54.77 103.692H41.23v.846h4.232a2.965 2.965 0 0 1 2.961 2.962c0 2.1 1.708 3.808 3.808 3.808h.846v-.846h-.846a2.965 2.965 0 0 1-2.962-2.962 3.785 3.785 0 0 0-1.444-2.962h6.944v-.846z"
        fill="#CD3F39"
      />
      <path
        d="M18 65.915V75h132v10.085a1.5 1.5 0 1 1-1 0V76h-33v9.085a1.5 1.5 0 1 1-1 0V76H82v9.085a1.5 1.5 0 1 1-1 0V76H48v9.085a1.5 1.5 0 1 1-1 0V76H17V65.915a1.5 1.5 0 1 1 1 0z"
        fill="#D3DCE0"
      />
      <g>
        <text fontSize="16" fontWeight="400" fill="#8C53C2">
          <tspan x="0" y="44">{`Spaces`}</tspan>
        </text>
        <g opacity=".15" stroke="#8C53C2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M122.5 2.5v2h-15V17a2.5 2.5 0 0 1-5 0V.5h7v2h13z" fill="#F4E8FF" />
          <path d="M122.5 4.5h3v12c0 1.66-1.34 3-3 3H105" />
        </g>
        <g opacity=".25" stroke="#8C53C2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M88.5 2.5v2h-15V17a2.5 2.5 0 0 1-5 0V.5h7v2h13z" fill="#F4E8FF" />
          <path d="M88.5 4.5h3v12c0 1.66-1.34 3-3 3H71" />
        </g>
        <g opacity=".35" stroke="#8C53C2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M54.5 2.5v2h-15V17a2.5 2.5 0 0 1-5 0V.5h7v2h13z" fill="#F4E8FF" />
          <path d="M54.5 4.5h3v12c0 1.66-1.34 3-3 3H37" />
        </g>
        <g stroke="#8C53C2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20.5 2.5v2h-15V17a2.5 2.5 0 0 1-5 0V.5h7v2h13z" fill="#F4E8FF" />
          <path d="M20.5 4.5h3v12c0 1.66-1.34 3-3 3H3" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/space-diagram.es6.js